import { useEffect, useRef } from "react";
import { useAdminUI } from "./AdminUIContext";
import styles from "./AdminShared.module.css";

const AdminConfirmModal = () => {
  const { confirmState, resolveConfirm } = useAdminUI();
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (!confirmState) return;
    const onKey = (e) => {
      if (e.key === "Escape") resolveConfirm(false);
    };
    window.addEventListener("keydown", onKey);
    confirmBtnRef.current?.focus();
    return () => window.removeEventListener("keydown", onKey);
  }, [confirmState, resolveConfirm]);

  if (!confirmState) return null;

  return (
    <div
      className={styles["modal-backdrop"]}
      role="presentation"
      onClick={() => resolveConfirm(false)}
    >
      <div
        className={styles["modal-panel"]}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-confirm-title"
        aria-describedby="admin-confirm-message"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="admin-confirm-title" className={styles["modal-title"]}>
          {confirmState.title}
        </h2>
        <div id="admin-confirm-message">
          {(Array.isArray(confirmState.message)
            ? confirmState.message
            : [confirmState.message]
          )
            .filter((part) => part != null && String(part).trim() !== "")
            .map((part, i) => (
              <p key={i} className={styles["modal-message"]}>
                {part}
              </p>
            ))}
        </div>
        <div className={styles["modal-actions"]}>
          <button
            type="button"
            className={styles["btn-ghost"]}
            onClick={() => resolveConfirm(false)}
          >
            {confirmState.cancelLabel}
          </button>
          <button
            ref={confirmBtnRef}
            type="button"
            className={
              confirmState.danger ? styles["btn-danger"] : styles["btn-primary"]
            }
            onClick={() => resolveConfirm(true)}
          >
            {confirmState.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminConfirmModal;
